import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Table from '../../usables/Table'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Button from '../../usables/small/ButtonReal'
import FileUpload from '../../usables/small/FileUpload'

export default function Students() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [students, setStudents] = useState([]);
  const [formData, setFormData] = useState({name: '', lastname: '', email:'', phone: '', school: '', avg_grade: ''})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: 'Moksleiviai',
    columns: [
      {
        Header: 'Vardas',
        accessor: 'person.name'
      },
      {
        Header: 'Pavardė',
        accessor: 'person.lastname'
      },
      {
        Header: 'Telefonas',
        accessor: 'person.phone'
      },
      {
        Header: 'El. paštas',
        accessor: 'person.email'
      },
      {
        Header: 'Klasė',
        accessor: 'class_name',
        Cell: (props) => {
          return (<span className={`w-fit px-4 py-1 rounded-full ${(props.value === 'nėra') ? 'bg-red-300' : 'bg-green-300'}`}>{props.value}</span>)
        },
      },
      {
        Header: 'Vid. pažymys',
        accessor: 'avg_grade'
      },
      {
        Header: 'Veiksmai',
        accessor: 'action'
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const downloadUsers = () => {
    axios.get(process.env.REACT_APP_API + '/student/download', config)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'download.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(err => {
        console.log(err.response.data)
      })
  }

  const createStudent = () => {
    axios.post(process.env.REACT_APP_API + '/student', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.student.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/students/' + res.data.student.id}>Daugiau</Link>
          res.data.class_name = 'nėra'
          setStudents(student => [res.data.student, ...student ])
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/student', config)
    .then(res => {
      if(res.status === 200){
        setStudents([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/students/' + data.id}>Daugiau</Link>
          data.class_name = (data.class_id === null) ? 'nėra' : data.student_class.name
          setStudents(student => [...student, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setStudents([]) //! Pašalinti prieš buildinant
      setStudents(people => [...people, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <h2>Moksleiviai</h2>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
              <Button text='Parsiųsti sąrašą' onClick={() => downloadUsers()} />&nbsp;
              {authUser().roles.admin &&
              <Modal showAddBtn={false} btnText='Įkelti sąrašą' title='Įkelti sąrašą' displaySubmit={false}>
                <FileUpload labelText='Įkelti moksleivių sąrašą' apiURI={process.env.REACT_APP_API + '/student/upload'} />
              </Modal>
              }
              <Table columns={tableColumns} data={students} />
            </>
          : <ClosingAlert type='warning' message='Nerasta mokomūjų dalykų' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {/* <Table columns={tableColumns} data={people} /> */}
    {/* Asmenys: 
    {people.map(person => {
      return <div key={person.id}>{JSON.stringify(person)} <Link className='text-violet-300 hover:text-violet-700' to={'/people/' + person.id}>Daugiau</Link></div>
    })} */}
    {authUser().roles.admin &&
    <Modal showAddBtn={true} title='Naujas moksleivis' saveText='Sukurti' submitFunction={() => createStudent()}>
      <div className='pt-5'>
        <Input
          label='Vardas'
          name='name'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <Input
          label='Pavardė'
          name='lastname'
          type='text'
          value={formData.lastname}
          onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
          />
        <Input
          label='El. paštas'
          name='email'
          type='email'
          value={formData.email}
          onChange={(e)=>setFormData({...formData, email: e.target.value})}
          />
        <Input
          label='Telefonas'
          name='phone'
          type='tel'
          value={formData.phone}
          onChange={(e)=>setFormData({...formData, phone: e.target.value})}
          />
        <Input
          label='Ankstesnė mokykla'
          name='school'
          type='text'
          value={formData.school}
          onChange={(e)=>setFormData({...formData, school: e.target.value})}
          />
        <Input
          label='Pažymių vidurkis'
          name='avg_grade'
          type='number'
          value={formData.avg_grade}
          onChange={(e)=>setFormData({...formData, avg_grade: e.target.value})}
          />
        </div>
      </Modal>
    }
    </>
  )
}